export const orderTypeIndex = {
    inPatient : "Internado",
    outPatient: "Ambulatorio"
}

export const translateOrderType = (type) => {
    return orderTypeIndex[type] || type;
}
